/* ============================================================
   LP共通JavaScript 3本セット — コピーして </body> 直前の <script> に内包する
   出典: CLAUDE.md 実装スタンダードJ（2026-07-03 移設）
   前提: スティッキーCTAのHTML（#sticky-cta）を配置していること（README参照）
   ============================================================ */

/* ① スライドインアニメーション発火（IntersectionObserver） */
(function () {
  var targets = document.querySelectorAll('.slide-left, .slide-right, .slide-up, .fade-in');
  if (!('IntersectionObserver' in window)) {
    targets.forEach(function (el) { el.classList.add('visible'); }); return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.15 });
  targets.forEach(function (el) { obs.observe(el); });
})();

/* ② パララックス（デスクトップのみ・STRENGTH=40px） */
(function () {
  if (window.matchMedia('(max-width: 768px)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var els = Array.prototype.slice.call(document.querySelectorAll('.parallax-bg'));
  var STRENGTH = 40; var ticking = false;
  function update() {
    var vh = window.innerHeight;
    els.forEach(function (img) {
      var section = img.parentElement;
      var rect = section.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > vh) return;
      var offset = (rect.top + rect.height / 2 - vh / 2) / (vh + rect.height) * STRENGTH * 2;
      img.style.transform = 'translateY(' + offset.toFixed(2) + 'px)';
    });
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
  update();
})();

/* ③ モバイルスティッキーCTA制御（sec-solutionを通過したら出現・sec-cta表示中は隠す・上スクロールで凹む） */
(function () {
  var el = document.getElementById('sticky-cta');
  if (!el) return;
  var shown = false;
  /* 上スクロール=読み返し中はバナーを凹ませて視界を空け、下スクロールで再表示（デフォルト挙動） */
  var lastY = window.scrollY;
  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    if (shown) {
      if (y < lastY - 4) el.classList.add('retract');
      else if (y > lastY + 4) el.classList.remove('retract');
    }
    lastY = y;
  }, { passive: true });
  var trigger = document.getElementById('sec-solution');
  if (trigger && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting && !shown && window.scrollY > trigger.offsetTop) {
          el.style.display = 'block'; shown = true;
        }
      });
    }, { threshold: 0 }).observe(trigger);
  }
  var finalCta = document.getElementById('sec-cta');
  if (finalCta && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        el.style.display = e.isIntersecting ? 'none' : (shown ? 'block' : 'none');
      });
    }, { threshold: 0.1 }).observe(finalCta);
  }
})();
